import {
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage';
import {rbacActions} from "../../config/rbac/actions.ts";
import {RestrictedRouteElement} from "../../components/RestrictedRouteElement.tsx";

export const PricesLayout = () => {


    return (
        <Routes>
            <Route
                path='/'
                element={<RestrictedRouteElement rbacAction={rbacActions.ListPrices}>
                    <IndexPage/></RestrictedRouteElement>}
            />
            <Route
                path='add'
                element={<RestrictedRouteElement rbacAction={rbacActions.CreatePrice}>
                    <AddPage/></RestrictedRouteElement>}
            />
            <Route
                path=':id'
                element={<RestrictedRouteElement rbacAction={rbacActions.GetPrice}>
                    <EditPage/></RestrictedRouteElement>}
            />
        </Routes>
    );
};
